<template>
  <svg
    id="contour_copia"
    data-name="contour copia"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 64"
  >
    <title>56_user-LIGHT</title>
    <path
      fill="#fff"
      class="cls-1"
      d="M32,4A12,12,0,1,1,20,16,12,12,0,0,1,32,4m0-4A16,16,0,1,0,48,16,16,16,0,0,0,32,0Z"
    />
    <path
      fill="#fff"
      class="cls-1"
      d="M32,39c20.76,0,27,4.71,27.89,21H4.1C5,43.71,11.24,39,32,39m0-4C9.58,35,1.12,40.86.11,59.79a4,4,0,0,0,4,4.21H59.89a4,4,0,0,0,4-4.21C62.88,40.86,54.42,35,32,35Z"
    />
  </svg>
</template>

<script>
export default {
  name: "UserIcon"
};
</script>


// WEBPACK FOOTER //
// src/icons/UserIcon.vue